import { render, staticRenderFns } from "./tesas-table.vue?vue&type=template&id=dcbbf32a&scoped=true&"
import script from "./tesas-table.vue?vue&type=script&lang=js&"
export * from "./tesas-table.vue?vue&type=script&lang=js&"
import style0 from "./tesas-table.vue?vue&type=style&index=0&id=dcbbf32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbbf32a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dcbbf32a', component.options)
    } else {
      api.reload('dcbbf32a', component.options)
    }
    module.hot.accept("./tesas-table.vue?vue&type=template&id=dcbbf32a&scoped=true&", function () {
      api.rerender('dcbbf32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/tesas-table.vue"
export default component.exports